export const getMultiCampaignAgroupSelectorStyle = () =>
  ({
    '@global': {
      '& .ba-campaign-selector,.ba-campaign-adgroup-selector': {
        '& .ba-list-selector': {
          border: '1px solid #BBB',
          height: 300,
          display: 'flex',
          flexDirection: 'column',

          '& .list-selector-item': {
            position: 'relative',
          },

          '& .list-selector-content': {
            flex: 1,
            overflow: 'auto',
          },

          '& .list-selector-select-all-bar': {
            padding: '5px 10px',
            color: '#1470A5',
            cursor: 'pointer',

            '& .arrow-button.enabled': {
              marginLeft: 6,
            },

            '& .arrow-button.remove': {
              marginRight: 6,
            },

            '& .enabled.arrow-button:before, & .arrow-button.remove:before': {
              verticalAlign: 'middle',
            },
          },
        },
      },
    },
  });
